import {getJsonWithCommonParams, postJsonWithCommonParams} from '../../common/request';
import {ICommonCommentItem, ICommonReplyItem} from '../../apis/comment/commonApiAdapter';
import RootStore, {dataStore} from '../../components/common/rootStore';
import {AContainerStoreBase} from '../../base/store';
import {action, observable, runInAction} from 'mobx';
import {ICommentApiResult, ICommentItem} from '../../../service/server/commentServer';
import {ICommentListApiData} from '../../apis/comment/apiAdapterFactory';
import {IEnvironment} from '../../../middleware/envi';
import {CommentPanel} from '../commentWrap/commentWrap';
import {addGlobalEventHandler, triggerGlobalEvent} from '../../common/globalEventHandle';
import {ICommentCreateData} from 'uciflow';
import {ICommentLikeData} from '../../../controller/comment';

export interface ICommentListModel {
  // instance: string;
  itemId: string;
  type: CommentPanel;
  // initItems: ICommonCommentItem[];
  // total: number;
  // lastIndex: number;
}

export enum RequestStatus  {
  none= 0,
  sending= 1,
  finished = 2,
}

let hasNoticeNative = false;

@dataStore<ICommentListModel>('container.comment.store')
export default class CommentListStore extends AContainerStoreBase {

  @observable
  public total: number;

  @observable
  public lastIndex: number;

  @observable
  public items: ICommonCommentItem[];

  @observable
  public hasMore: boolean;
  public itemId;
  public type: CommentPanel;
  private requestStatusMap: {[key: number]: RequestStatus} = {};

  constructor(root, config: ICommentListModel) {
    super();
    this.root = root;
    this.total = 0;
    this.lastIndex = 0;
    this.items = [];
    this.hasMore = true;
    this.itemId = config.itemId;
    this.type = config.type;
    addGlobalEventHandler('commentInput:add:comment', (event) => {
        this.onAddCommentEvent(event.data.newItem);
    });
    addGlobalEventHandler('commentInput:init:history', (event) => {
        const historyItems = event.data.commentItems;
        historyItems.forEach((item) => {
            const findItem = this.items.find((currItem) => {
                return currItem.userName === item.userName && currItem.message === item.message;
            });
            if (!findItem) {
                this.onAddCommentEvent(item);
            }
        });
    });
  }

  @action
  public loadCommentList = async (queryIndex: number) => {
    if (this.requestStatusMap[queryIndex]) {
      return;
    }
    try {
      const envi = window._ENVI_INFO as IEnvironment;
      const url = `/api/comment/list/story/common`;
      this.requestStatusMap[queryIndex] = RequestStatus.sending;
      const data = await getJsonWithCommonParams
        < ICommentApiResult < ICommentListApiData < 'common' >>> (url, {
          item_id: this.itemId,
          query_index: queryIndex,
          lang: envi.languageFullName,
          type: this.type,
        });
      runInAction(() => {
        if (data.data) {
          if (data.data.hotComments) {
            data.data.hotComments.forEach((item) => {
              this.items.push(item);
            });
          }
          if (data.data.comments) {
            data.data.comments.forEach((item) => {
              this.items.push(item);
            });
          }
          this.requestStatusMap[queryIndex] = RequestStatus.finished;
          this.total = data.data.total;
          this.lastIndex = data.data.lastIndex;
          this.hasMore = data.data.lastIndex > 0;
          if (!hasNoticeNative) {
            const param = {
              comment_count: this.total, // 评论数
              comment_state: 1, // 0：不能发评论，1:可以发评论
              article_id: this.itemId, // 文章id
              success(result) { console.log('ucapi.comment.notifyState succ', result); },
              fail(error) { console.log('ucapi.comment.notifyState fail', param); },
            };

            if (window.ucapi.comment) {
              try {
                window.ucapi.comment.notifyState(param);
                // console.log('ucapi.comment.notifyState succ', param);
              } catch (e) {
                console.error('ucapi.comment.notifyState\n', e + '');
              }
            } else {
              console.log(param);
            }
            hasNoticeNative = true;
          }
        } else {
          this.requestStatusMap[queryIndex] = RequestStatus.none;
        }
      });
    } catch (ex) {
      console.log(ex);
    }
  }

  @action.bound
  public likeItem = async (type: 'comment' | 'reply', item: ICommonCommentItem|ICommonReplyItem) => {

    const postJsonPromise = postJsonWithCommonParams(`/api/comment/like/${type}/story`, {
      item_id: item.itemId,
      comment_id: item.commentId,
      comment_ref_id: `${item.itemId}_comment`,
      ...(type === 'reply' ? {
        reply_id: (item as ICommonReplyItem).replyId,
      } : {}),
    } as ICommentLikeData);
    // await postJsonPromise;
  }

  public toJson(): any {
    return {
      total: this.total,
      lastIndex: this.lastIndex,
      type: this.type,
      itemId: this.itemId,
      hasMore: this.hasMore,
      items: this.items,
    };
  }

  @action
  private onAddCommentEvent = (newItem: ICommonCommentItem) => {
    this.items.unshift(newItem);
    console.log('add event', newItem, this.items);
  }
}
